import React, {Component} from 'react';
import CaptureLoanableValuesView from "./CaptureLoanableValuesView";
import ContextMenu from "../../../components/contextMenu";
import {
    ADD_POSITION_LOANABLE_ROUTE,
    CAPTURE_LOANABLE_VALUES_ROUTE,
    EDIT_POSITION_LOANABLE_ROUTE
} from "../../../utils/constants/RoutesConstants";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {CaptureLoanableValuesService} from "../../../service/ptm/CaptureLoanableValuesService";
import {Growl} from "primereact/growl";

export default class CaptureLoanableValuesContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.captureLoanableValuesService = new CaptureLoanableValuesService();
        this.getDataLoanableValues = this.getDataLoanableValues.bind(this);
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }

        this.state = {
            dataLoanableValues: this.getDataLoanableValues(),
            accountObj: {},
            instrumentObj: {},
            isLoading: true,
            expanded: false,
        };
        this.loanableValuesActionTemplate = this.loanableValuesActionTemplate.bind(this);
        this.onChangeDropdown = this.onChangeDropdown.bind(this);
        this.handleSelectedRow = this.handleSelectedRow.bind(this);
        this.searchLoanableValues = this.searchLoanableValues.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.cancelPosition = this.cancelPosition.bind(this);
        this.redirectAddPosition = this.redirectAddPosition.bind(this);
        this.redirectEditPosition = this.redirectEditPosition.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    /**
     * Función que hace una consulta al back para obtener la lista de
     * las posiciones y colocar la lista en la tabla de la pantalla
     * principal
     */
    getDataLoanableValues(idEmisora, account) {
        this.loading(true);
        this.captureLoanableValuesService.getListOrdersLoanableValues(idEmisora, account)
            .then((resp) => {
                this.setState({
                    dataLoanableValues: resp,
                });
                this.loading(false);
            });
    }

    searchLoanableValues() {
        let idEmisora = this.state.instrumentObj.idEmisora ?
            this.state.instrumentObj.idEmisora : 0;
        let account = this.state.accountObj.cuenta ?
            this.state.accountObj.cuenta : '';
        this.getDataLoanableValues(idEmisora, account);
    }

    clearFilters() {
        this.setState({
            accountObj: [],
            instrumentObj: [],
        });

        this.getDataLoanableValues(0, '');
    }

    /**
     * Función que maneja la selección de una fila pero esta vez es de la opción
     * que se seleccionó en la lista dentro se las cuentas para editarla o
     * eliminarla
     * @param event Evento que trae la información de la opción seleccionada.
     */
    handleSelectedRow = (event) => {
        this.setState({
            selectedPosition: event.value,
        });
    }

    onChangeDropdown(event) {
        let {name, value} = event.target;
        value = value === null ? {} : value;
        this.setState({[name]: value});
    }


    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    loanableValuesActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar Postura", action: this.redirectEditPosition},
            {label: "Cancelar Postura", action: this.confirmationRef.openConfirmationMessage},
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectEditPosition() {
        this.props.history.push({
            pathname: EDIT_POSITION_LOANABLE_ROUTE,
            state: {
                returnPath: CAPTURE_LOANABLE_VALUES_ROUTE,
                selectedPosition: this.state.selectedPosition,
            },
        });
    }

    /**
     * Función que toma la posición seleccionada y la elimina de la tabla.
     * Para ello hace una petición al servicio CaptureGuaranteesService
     */
    cancelPosition() {
        this.loading(true);
        if (this.state.selectedPosition) {
            let folio = this.state.selectedPosition.folio;
            this.captureLoanableValuesService.cancelPosition(folio)
                .then(res => {
                    this.getDataLoanableValues();
                    if (res.message === 'Success') {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'La postura se ha cancelado exitosamente.'
                        });
                    } else if (res.message !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                });
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'No se pudo eliminar elemento. Posicion no seleccionada.'
            });
        }
        this.loading(false);
    }

    /**
     * Función que redirecciona a la pantalla de agregar posición
     */
    redirectAddPosition() {
        this.props.history.push({
            pathname: ADD_POSITION_LOANABLE_ROUTE,
            state: {
                returnPath: CAPTURE_LOANABLE_VALUES_ROUTE,
            },
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Desea cancelar la postura seleccionada?"
                                            afterHide={() => this.setState({selectedPosition: {}})}
                                            action={this.cancelPosition}/>;
        const {
            dataLoanableValues, accountObj, instrumentObj, isLoading,
            selectedPosition
        } = this.state;
        return (
            <CaptureLoanableValuesView dataLoanableValues={dataLoanableValues}
                                       isLoading={isLoading}
                                       accountObj={accountObj}
                                       instrumentObj={instrumentObj}
                                       selectedPosition={selectedPosition}
                                       messagesGrowl={messagesGrowl}
                                       confirmationMsg={this.confMsg}
                                       searchLoanableValues={this.searchLoanableValues}
                                       clearFilters={this.clearFilters}
                                       redirectAddPosition={this.redirectAddPosition}
                                       loanableValuesActionTemplate={this.loanableValuesActionTemplate}
                                       onChangeDropdown={this.onChangeDropdown}
                                       handleSelectedRow={this.handleSelectedRow}
                                       loading={this.loading}
            />
        );
    }
}
